import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Slider from "react-slick";
import ContainerDimensions from "react-container-dimensions";
import { browserHistory } from "react-router";
import BacktestService from "../../../../service/backtest.service";
import RiskRangeChart from "../../../common/riskRangeChart";
import ModelCard from "../model_card";
import Donut from "../../../d3Components/donut";
// import AssetAllocationTable from "./asset_allocation_table";
import TunersAndInput from "../common/tunersAndinput";
import SliderSettings from "../common/sliderSettings";
import "./AssetAllocationFunds.style.scss";
import Annualized from "../../../PortfolioDashboard/navigationPages/performance/yearlyPerformance/annualized";
import AssetAllocationHelper from "./helper";
// import PerformanceHelper from "../../../PortfolioDashboard/navigationPages/performance/performance.helper";
import CreatePortfolioHelper from "../helper";
import debounce from "../../../common/debounce";

class AssetAllocationFunds extends Component {
  state = {
    tableData: [],
    pieData: [],
    riskRangePercentage: 0,
    colors: [
      "#5262ad",
      "#6372b5",
      "#7581bd",
      "#8691c6",
      "#97a1ce",
      "#a9b1d6",
      "#bac0de",
      "#cbd0e6",
    ],
    createBtnDisabled: true,
    creatingPortfolioSpinner: false,
    failedCreatingPortfolio: false,
    noScenarioIDreturned: false,
    allocations_are_greater_than_zero: false,
    donutAllocationWarningMsg: false,
    minRange: 0,
    maxRange: 0,
    modelPortfolioModified: [],
    annualized_data: [],
  };

  componentDidMount() {
    const {
      build_modelportfolios,
      allocations,
      optimization_params,
      build_histmetrics,
    } = this.props;

    if (build_modelportfolios && build_modelportfolios.length > 0) {
      this.modifyData({
        modelPortfolios: build_modelportfolios,
        allocations,
        optimization_params,
        build_histmetrics,
      });

      let getRiskMinMaxRange = CreatePortfolioHelper.getRiskMinMaxRange({
        modelportfolios: this.props.build_modelportfolios,
      });
      this.addEmptyCards({ build_modelportfolios });
      let _allocations = this.get_initial_allocations({
        build_modelportfolios,
      });

      this.props.setAllocations(_allocations);

      if (allocations && Object.keys(allocations).length > 0) {
        let display = this.checkAllocations({ data: allocations });

        this.setState({
          allocations_are_greater_than_zero: display,
          minRange: getRiskMinMaxRange["min"],
          maxRange: getRiskMinMaxRange["max"],
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      build_modelportfolios,
      allocations,
      scenario_name,
      optimization_params,
      build_histmetrics,
    } = nextProps;

    if (
      nextProps.build_modelportfolios &&
      nextProps.build_modelportfolios.length > 0 &&
      JSON.stringify(this.props.build_modelportfolios) !==
        JSON.stringify(nextProps.build_modelportfolios)
    ) {
      this.addEmptyCards({ build_modelportfolios });
    }

    if (
      allocations &&
      Object.keys(allocations).length > 0 &&
      JSON.stringify(allocations) !== JSON.stringify(this.props.allocations)
    ) {
      let display = this.checkAllocations({ data: allocations });

      let getRiskMinMaxRange = CreatePortfolioHelper.getRiskMinMaxRange({
        modelportfolios: this.props.build_modelportfolios,
      });

      this.modifyData({
        modelPortfolios: build_modelportfolios,
        allocations,
        optimization_params,
        build_histmetrics,
      });

      let sum_of_allocations = this.getSumOfAllocation({ allocations });
      this.setState({
        allocations_are_greater_than_zero: display,
        createBtnDisabled:
          sum_of_allocations === 100 && scenario_name ? false : true,
        donutAllocationWarningMsg: sum_of_allocations === 100 ? false : true,
        minRange: getRiskMinMaxRange["min"],
        maxRange: getRiskMinMaxRange["max"],
      });
    }
  }

  addEmptyCards = ({ build_modelportfolios }) => {
    // if length is lessthan 5 add empty card
    if (build_modelportfolios && build_modelportfolios.length < 4) {
      let modified = [...build_modelportfolios];
      let obj = {
        name: "test",
        id: "",
        data: [],
      };
      modified.push(obj, obj);
      this.setState({
        modelPortfolioModified: modified,
      });
    } else {
      this.setState({
        modelPortfolioModified: build_modelportfolios,
      });
    }
  };

  get_initial_allocations = ({ build_modelportfolios }) => {
    if (build_modelportfolios && build_modelportfolios.length > 0) {
      let allocation = {};
      for (let i = 0; i < build_modelportfolios.length; i++) {
        allocation[build_modelportfolios[i]["id"]] = 0;
      }
      return allocation;
    }
  };
  modifyData = ({
    modelPortfolios,
    allocations,
    optimization_params,
    build_histmetrics,
  }) => {
    const { colors } = this.state;
    const pieDataModify = ({ modelPortfolios, allocations }) => {
      let pieData = [];

      if (
        modelPortfolios &&
        modelPortfolios.length > 0 &&
        allocations &&
        Object.keys(allocations).length > 0
      ) {
        for (let i = 0; i < modelPortfolios.length; i++) {
          let pie = {};

          let title = modelPortfolios[i]["data"][0]["scenario_name"]
            ? modelPortfolios[i]["data"][0]["scenario_name"]
            : modelPortfolios[i]["name"];

          pie["color"] = colors[i];
          pie["value"] = allocations[modelPortfolios[i]["id"]] * 1;
          pie["name"] = title;
          pieData.push(pie);
        }
        let unAllocated = {
          color: "#cccccc",
          name: "",
        };
        let unAllocatedVal = 100 - this.getSumOfAllocation({ allocations });

        unAllocated["value"] = unAllocatedVal < 0 ? 0 : unAllocatedVal;
        if (unAllocatedVal > 0) {
          pieData.push(unAllocated);
        }
      }

      return pieData;
    };

    const getRiskLevel = ({ allocations, optimization_params }) => {
      let _percentage_allocation = {};
      for (let id in allocations) {
        let val =
          optimization_params[id] &&
          optimization_params[id]["max_vol"] &&
          +optimization_params[id]["max_vol"] * (+allocations[id] / 100);
        _percentage_allocation[id] = val;
      }
      let total = this.getSumOfAllocation({
        allocations: _percentage_allocation,
      });
      return total;
    };

    let modified = pieDataModify({ modelPortfolios, allocations });
    let riskRangePercentage = getRiskLevel({
      allocations,
      optimization_params,
    });

    const getAnnualizetData = ({ allocations, build_histmetrics }) => {
      var sumObjectsByKey = (...objs) =>
        Object.values(
          objs.reduce((a, e) => {
            a[e.metric_name] = a[e.metric_name] || {
              metric_name: e.metric_name,
            };

            for (const k in e) {
              if (k !== "metric_name") {
                a[e.metric_name][k] = a[e.metric_name][k]
                  ? a[e.metric_name][k] + e[k]
                  : e[k];
              }
            }

            return a;
          }, {})
        );

      let data;
      for (let id in allocations) {
        if (
          id &&
          build_histmetrics &&
          build_histmetrics[id] &&
          build_histmetrics[id].length > 0
        ) {
          let percentage = allocations[id] * 1;
          let arr = AssetAllocationHelper.annualized_getSpecificData({
            data: build_histmetrics[id],
            percentage,
          });

          if (data && data.length > 0 && percentage && percentage > 0) {
            data = sumObjectsByKey(...data, ...arr);
          } else if (percentage && percentage > 0) {
            data = arr;
          }
        }
      }
      return data;
    };
    // let annualized_data = getAnnualizetData({ allocations, build_histmetrics });
    let added_rect = AssetAllocationHelper.addGroupRect({
      data: getAnnualizetData({ allocations, build_histmetrics }),
    });

    this.setState({
      pieData: modified,
      riskRangePercentage,
      annualized_data: added_rect,
    });
  };

  getSumOfAllocation = ({ allocations }) => {
    let total = 0;
    if (!allocations || Object.keys(allocations).length === 0) {
      return total;
    }
    for (let i in allocations) {
      total += allocations[i] * 1;
    }
    return total;
  };
  portfolioNameHandler = (name) => {
    const { setAssetAllocationScenarioName, allocations } = this.props;

    setAssetAllocationScenarioName({
      scenario_name: name,
      group: "asset_allocation_funds",
    });

    let sum_of_allocations = this.getSumOfAllocation({ allocations });

    this.setState({
      createBtnDisabled: sum_of_allocations === 100 && name ? false : true,
    });
  };

  tunersHandler = (obj) => {
    const { id, type, value } = obj;
    const { tunersHandler } = this.props;
    tunersHandler({
      id,
      type,
      value: +value,
    });
  };

  allocationHandler = ({ id, value, e }) => {
    e.preventDefault();
    this.props.setAllocationsValues({ value, id });
  };

  checkAllocations = ({ data }) => {
    let display = false;

    for (let id in data) {
      let a = data[id];
      if (a > 0) {
        display = true;
      }
    }
    return display;
  };

  finish = () => {
    const {
      scenario_name,
      allocations,
      resetAssetAllocationsFunds,
    } = this.props;
    let allocation_funds = {};

    for (let id in allocations) {
      if (allocations[id] && allocations[id] !== 0) {
        allocation_funds[id] = (allocations[id] / 100).toString();
      }
    }
    BacktestService.createPortfolioAssetAllocations({
      scenario_name,
      portfolio_type: "AA",
      ui_params: JSON.stringify(allocation_funds),
    })
      .then((res) => {
        if (res) {
          this.setState({
            creatingPortfolioSpinner: false,
          });
          if ("scenario_id" in res && res["scenario_id"]) {
            this.setState({
              noScenarioIDreturned: false,
            });
            browserHistory.push("/portfolio/" + res.scenario_id);
          } else {
            this.setState({
              noScenarioIDreturned: true,
            });

            setTimeout(
              () =>
                this.setState({
                  noScenarioIDreturned: false,
                }),
              500
            );
          }

          // reset asset allocaion funds
          resetAssetAllocationsFunds();
        }
      })
      .catch((err) => {
        console.log(err);

        this.setState({
          creatingPortfolioSpinner: false,
          failedCreatingPortfolio: true,
          noScenarioIDreturned: false,
        });

        setTimeout(
          () => this.setState({ failedCreatingPortfolio: false }),
          5000
        );
      });
  };
  createPortfolioHandler = () => {
    this.setState({
      creatingPortfolioSpinner: true,
    });

    debounce(this.finish(), 1000);
  };
  render() {
    const {
      // active_portfolio_id,
      // optimization_params,
      scenario_name,
      // build_modelportfolios,
      // backtest_data,
      build_histmetrics,
      allocations,
      direct_review_orig_scenario_id,
      direct_review_portfolio,
    } = this.props;
    const {
      // tableData,
      pieData,
      modelPortfolioModified,
      createBtnDisabled,
      creatingPortfolioSpinner,
      failedCreatingPortfolio,
      noScenarioIDreturned,
      allocations_are_greater_than_zero,
      riskRangePercentage,
      donutAllocationWarningMsg,
      annualized_data,
      minRange,
      maxRange,
    } = this.state;

    // let max_value =
    //   active_portfolio_id &&
    //   optimization_params[active_portfolio_id] &&
    //   optimization_params[active_portfolio_id]["max_vol"]
    //     ? optimization_params[active_portfolio_id]["max_vol"]
    //     : 0;

    // let min_return =
    //   active_portfolio_id &&
    //   optimization_params[active_portfolio_id] &&
    //   optimization_params[active_portfolio_id]["min_return"]
    //     ? optimization_params[active_portfolio_id]["min_return"]
    //     : 0;

    return (
      <div className="AssetAllocationFunds">
        <div className="AssetAllocationFunds__sliderHolder">
          {modelPortfolioModified &&
          modelPortfolioModified.length > 0 &&
          // Object.keys(backtest_data).length > 0 &&
          build_histmetrics &&
          Object.keys(build_histmetrics).length > 0 &&
          Object.keys(allocations).length > 0 ? (
            <Slider {...SliderSettings}>
              {modelPortfolioModified.map((obj, i) => (
                <div key={`key-${i}`}>
                  <ContainerDimensions>
                    {({ width }) => (
                      <Fragment>
                        {width > 0 ? (
                          <ModelCard
                            id={`assetallocation-portfolio-cards-${
                              obj && obj.id ? obj.id : ""
                            }`}
                            val={obj && obj.id ? obj.id : ""}
                            width={width}
                            // radioButtonHandler={this.radioButtonHandler}
                            // defaultChecked={
                            //   obj && obj.id && obj.id === defaultChecked
                            //     ? true
                            //     : false
                            // }
                            headingTxt={`${
                              obj["data"] &&
                              obj["data"][0] &&
                              obj["data"][0]["scenario_name"]
                                ? obj["data"][0]["scenario_name"]
                                : obj["data"] && obj["data"][0]
                                ? obj["data"][0]["description"]
                                : ""
                            }`}
                            // footerTxt={"Start with this portfolio"}
                            // backtest_data={backtest_data}
                            perfHistmetrics={build_histmetrics[obj.id]}
                            benchmarkName={
                              obj["data"] &&
                              obj["data"][0] &&
                              obj["data"][0]["benchmark_name"]
                                ? `${obj["data"][0]["benchmark_name"]}`
                                : null
                            }
                            // radioButtonName="modelPortfolio"
                            allocation_and_Slider={true}
                            allocationHandler={this.allocationHandler}
                            allocations={allocations}
                          />
                        ) : null}
                      </Fragment>
                    )}
                  </ContainerDimensions>
                </div>
              ))}
            </Slider>
          ) : null}
        </div>
        {allocations_are_greater_than_zero ? (
          <Fragment>
            <RiskRangeChart
              value={riskRangePercentage}
              min={minRange}
              max={maxRange}
            />
            {/* {tableData && tableData.length > 0 ? (
          <AssetAllocationTable Data={tableData} />
        ) : null} */}
            <div className="container-fluid">
              <div className="row no-gutters">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 px-0">
                  {pieData && pieData.length > 0 ? (
                    <div className="AssetAllocationFunds__donut">
                      <Donut
                        id="donut_01"
                        width={450}
                        height={450}
                        label="Asset allocation"
                        data={pieData}
                        allocationWarningMsg={donutAllocationWarningMsg}
                      />
                    </div>
                  ) : null}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 px-0">
                  {annualized_data && annualized_data.length > 0 ? (
                    <Annualized
                      annuaized_yearly_data={annualized_data}
                      benchmark_name=""
                      display_orig_portfolio={false}
                      model_name={null}
                      typeName="Benchmark"
                    />
                  ) : null}
                </div>
              </div>
            </div>
            <TunersAndInput
              scenario_name={scenario_name}
              portfolioNameHandler={this.portfolioNameHandler}
              // disabling btn for now if its edit portfolio
              // btnDisabled={createBtnDisabled}
              btnDisabled={
                direct_review_orig_scenario_id && direct_review_portfolio
                  ? true
                  : createBtnDisabled
              }
              displayTuners={false}
              btnHandler={this.createPortfolioHandler}
              creatingPortfolioSpinner={creatingPortfolioSpinner}
              failedCreatingPortfolio={failedCreatingPortfolio}
              noScenarioIDreturned={noScenarioIDreturned}
              allocationHundredPercentMessage={donutAllocationWarningMsg}
            />
          </Fragment>
        ) : null}
      </div>
    );
  }
}

AssetAllocationFunds.propTypes = {
  donutData: PropTypes.array,
};
export default connect(
  ({
    buildPortfolio: {
      build_modelportfolios,
      asset_allocation_funds: {
        active_portfolio_id,
        scenario_name,
        allocations,
      },
      backendParams: { optimization_params },
      // backtest_data,
      build_histmetrics,
      direct_review_orig_scenario_id,
      direct_review_portfolio,
    },
  }) => ({
    build_modelportfolios,
    optimization_params,
    active_portfolio_id,
    scenario_name,
    // backtest_data,
    build_histmetrics,
    allocations,
    direct_review_orig_scenario_id,
    direct_review_portfolio,
  }),
  (dispatch) => ({
    setAssetAllocationScenarioName: ({ scenario_name, group }) =>
      dispatch({
        type: "BUILD_SET_SCENARIO_NAME",
        payload: { scenario_name, group },
      }),
    tunersHandler: ({ id, type, value }) =>
      dispatch({
        type: "COMMON_TUNERS_HANDLER",
        payload: { id, type, value },
      }),
    setAllocations: (payload) =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_SET_ALLOCATION_FUNDS_ALLOCATION",
        payload,
      }),
    setAllocationsValues: ({ value, id }) =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_SET_ALLOCATION_FUNDS_ALLOCATION_VALUES",
        payload: { value, id },
      }),
    resetAssetAllocationsFunds: () => {
      dispatch({
        type: "RESET_BUILD_A_PORTFOLIO_ALLOCATIONS_FUNDS",
      });
    },
  })
)(AssetAllocationFunds);



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/asset_allocation_funds/AssetAllocationFunds.jsx